import React, { useEffect, useState } from "react";
import BreadCrumb from "common/breadcrumb";

import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";

import UserInvitationComponent from "./onboard/cmp-user-invitation";
import TenantInforComponent from "./onboard/cmp-tenant-info";
import TenantUsersComponent from "./onboard/cmp-tenant-user-list";

import { Tenant } from "models/tenant/tenant";
import { BrandingData } from "admin-portal/settings/branding";
import { useLocation, useParams } from "react-router-dom";
import { GetTenantDetails } from "api/tenant";
import LoadingComponent from "common/components/loader";
import SearchNotFoundComponent from "common/components/search-not-found";
import { RoutePath } from "routes/route-path";
import { TenantType } from "models/enums";

import NotificationSettingsComponent from "./onboard/cmp-notification-settings";

import { AppDispatch } from "slices/store";
import { useAppSelector, useAppDispatch } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";

const TenantEditPage = () => {
  //const { id } = useParams();

  const dispatch: AppDispatch = useAppDispatch();
  const { loggedInuser } = useAppSelector(getAuthState);

  const [loading, setLoading] = useState(false);
  const [tenant, setTenant] = useState<Tenant>();

  const [activeTab, setActiveTab] = React.useState<string>("tab-general");
  const [systemTenant, setSystemTenant] = useState(false);

  const handleTabSelect = (eventKey: string | null) => {
    if (eventKey === "tab-users" || eventKey === "tab-admin-users") {
      // This is where you can force TenantUsersComponent to refresh data
      // For example, you can set a state that triggers a refresh
      setTenant((prevTenant) => ({ ...prevTenant, refresh: true }));
    }
    setActiveTab(eventKey || "tab-general");
  };

  const ontenantSave = (tnt: Tenant) => {
    setTenant({ ...tnt });
  };

  // Retrieve query parameters
  /*   const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tenantId = searchParams.get("id"); */
  const tenantId = loggedInuser?.activeTenantId;

  useEffect(() => {
    if ((tenantId ?? "").length > 0) {
      loadTenant(tenantId!);
    }
  }, [tenantId]);

  const loadTenant = async (tenantId: string) => {
    setLoading(true);
    const res = await GetTenantDetails(tenantId);
    if (!(res?.status?.isError ?? false) && res?.data) {
      setTenant(res?.data ?? {});
      // setTotal(res?.totalResultCount ?? 0);
      const _isSystem = res?.data?.tenantTypeId == TenantType.SYSTEM;
      setSystemTenant(_isSystem);
    } else {
      // setData([]);
      // setTotal(0);
      console.log("no tenant found");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <BreadCrumb title={"Edit " + BrandingData.bussinessDomain} pageTitle={BrandingData.bussinessDomain + " Manage"} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <LoadingComponent></LoadingComponent>
              ) : (tenant?.id ?? "") == "" ? (
                <>
                  <SearchNotFoundComponent title="Sorry! No Result Found">
                    <p className="mb-0 text-slate-500 dark:text-zink-200">
                      We've searched {BrandingData.bussinessDomain.toLocaleLowerCase()} matched to your criteria, We did
                      not find any.
                    </p>
                  </SearchNotFoundComponent>
                </>
              ) : (
                <Tab.Container defaultActiveKey={activeTab} onTabChange={handleTabSelect} activeTabKey={activeTab}>
                  <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                    <Nav.Item eventKey="tab-general" className="group">
                      <a
                        /*   href={`#${RoutePath.Admin_TenantEdit}`} */
                        data-tab-toggle
                        data-target="tab-general"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        General
                      </a>
                    </Nav.Item>
                    {/*          <Nav.Item eventKey="tab-admin-users" className="group">
                      <a                       
                        data-tab-toggle
                        data-target="tab-admin-users"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        System Users
                      </a>
                    </Nav.Item> */}
                    {!systemTenant && (
                      <Nav.Item eventKey="tab-users" className="group">
                        <a
                          /*    href={`#${RoutePath.Admin_TenantEdit}`} */
                          data-tab-toggle
                          data-target="tab-users"
                          className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                        >
                          Users
                        </a>
                      </Nav.Item>
                    )}

                    <Nav.Item eventKey="tab-user-invite" className="group">
                      <a
                        /*  href={`#${RoutePath.Admin_TenantEdit}`} */
                        data-tab-toggle
                        data-target="tab-user-invite"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        Invite a User
                      </a>
                    </Nav.Item>

                    <Nav.Item eventKey="tab-notifications" className="group">
                      <a
                        /*  href={`#${RoutePath.Admin_TenantEdit}`} */
                        data-tab-toggle
                        data-target="tab-notifications"
                        className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                      >
                        Notification Settings
                      </a>
                    </Nav.Item>
                  </Nav>

                  <Tab.Content className="mt-5 tab-content">
                    <Tab.Pane eventKey="tab-general" id="tab-general">
                      <div className="mb-0">
                        <TenantInforComponent tenant={tenant} onTenantSaveSuccess={ontenantSave}></TenantInforComponent>
                      </div>
                    </Tab.Pane>
                    {/*     <Tab.Pane eventKey="tab-admin-users" id="tab-admin-users">
                      <div className="mb-0">
                        <TenantAdminUsersComponent tenant={tenant}></TenantAdminUsersComponent>
                      </div>
                    </Tab.Pane> */}
                    {!systemTenant && (
                      <Tab.Pane eventKey="tab-users" id="tab-users">
                        <div className="mb-0">
                          <TenantUsersComponent tenant={tenant}></TenantUsersComponent>
                        </div>
                      </Tab.Pane>
                    )}
                    <Tab.Pane eventKey="tab-user-invite" id="tab-user-invite">
                      <div className="mb-0">
                        <UserInvitationComponent tenant={tenant}></UserInvitationComponent>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="tab-notifications" id="tab-notifications">
                      <NotificationSettingsComponent></NotificationSettingsComponent>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TenantEditPage;
